<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.glacctNo"
                          :label="labels.glacctNo"
                          :error-messages="errors.collect('glacctNo')"
                          data-vv-name="glacctNo"
                          :data-vv-as="labels.glacctNo"
                          v-validate="'max:16'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.description"
                          :label="labels.description"
                          :error-messages="errors.collect('description')"
                          data-vv-name="description"
                          :data-vv-as="labels.description"
                          v-validate="'max:40'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.branch"
                          :label="labels.branch"
                          :error-messages="errors.collect('branch')"
                          data-vv-name="branch"
                          :data-vv-as="labels.branch"
                          v-validate="'max:4'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.fund"
                          :label="labels.fund"
                          :error-messages="errors.collect('fund')"
                          data-vv-name="fund"
                          :data-vv-as="labels.fund"
                          v-validate="'max:4'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.acctNoSfx"
                          :label="labels.acctNoSfx"
                          :error-messages="errors.collect('acctNoSfx')"
                          data-vv-name="acctNoSfx"
                          :data-vv-as="labels.acctNoSfx"
                          v-validate="'max:4'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.curr"
                          :label="labels.curr"
                          :error-messages="errors.collect('curr')"
                          data-vv-name="curr"
                          :data-vv-as="labels.curr"
                          v-validate="'max:4'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="showMore">
                      <v-flex xl3 lg4 xs6>
                        <v-autocomplete
                          v-model="filters.postType"
                          :items="postTypeList"
                          :label="labels.postType"
                          item-text="label"
                          item-value="value"
                          data-vv-name="postType"
                          :data-vv-as="labels.postType"
                          :error-messages="errors.collect('postType')"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click.native="showMore = true" v-if="!showMore">Show More Filters</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <!--Search Results-->
        <v-flex xs12>
          <v-card>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card-title>
                  <v-checkbox :label="labels.inclClosed" v-model="filters.inclClosed" @change="fetchData(false)"></v-checkbox>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark class=" mr-2" @click="doNew">
                    New GL Account
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    v-bind:options.sync="pagination"
                    :server-items-length="totalItems"
                    :loading="loading"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td class="text-xs-left">{{ row.item.glacctNo }}</td>
                        <td class="text-xs-left">{{ row.item.description }}</td>
                        <td class="text-xs-left">{{ row.item.branch }}</td>
                        <td class="text-xs-left">{{ row.item.fund }}</td>
                        <td class="text-xs-left">{{ row.item.acctNoSfx }}</td>
                        <td class="text-xs-left">{{ row.item.curr }}</td>
                        <td class="text-xs-left">{{ postType(row.item.postType) }}</td>
                        <td class="table-action-header">
                          <table-action :rowData="row" review @review="doReview(row.item)" query @query="doQuery(row.item)"></table-action>
                        </td></tr
                    ></template>
                  </v-data-table>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-card>
    </v-flex>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { postType } from '@/const/acct/glAcct'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      headers: [
        { text: 'GL Account No.', value: 'glacctNo' },
        { text: 'Description', value: 'description' },
        { text: 'Branch', value: 'branch' },
        { text: 'Fund', value: 'fund' },
        { text: 'Account No. Suffix', value: 'acctNoSfx' },
        { text: 'Currency', value: 'curr' },
        { text: 'Post Type', value: 'postType' },
        TableConst.tableActionHeader
      ],
      labels: {
        glacctNo: 'GL Account No.',
        description: 'Description',
        branch: 'Branch',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        curr: 'Currency',
        postType: 'Post Type',
        inclClosed: 'Include Closed GL Accounts'
      },
      filters: {
        glacctNo: null,
        description: null,
        branch: null,
        fund: null,
        acctNoSfx: null,
        curr: null,
        postType: null,
        inclClosed: false
      },
      sideFunction: [
        {
          text: 'Debtors Control Interface',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'glDebtCtrl' }
        },
        {
          text: 'Premium & Claims Interface',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'glMapping' }
        }
      ],
      showMore: false,
      totalItems: 0,
      toogleArray: [false],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.menu.glacctNoList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((glacctNo) => {
                const convertList = {
                  glacctNo: glacctNo.glacctNo,
                  description: glacctNo.description,
                  branch: glacctNo.branch,
                  fund: glacctNo.fund,
                  acctNoSfx: glacctNo.acctNoSfx,
                  curr: glacctNo.curr,
                  postType: glacctNo.postType
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doFilters() {
      this.pagination.page = 1
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.glacctNo = null
      this.filters.description = null
      this.filters.branch = null
      this.filters.fund = null
      this.filters.acctNoSfx = null
      this.filters.curr = null
      this.filters.postType = null
      this.fetchData(false)
    },
    doNew() {
      const commit = {
        branch: 'new',
        glacctNo: 'new',
        fund: null,
        acctNoSfx: null,
        curr: null,
        postType: null
      }
      sessionStorage.setItem('glacctNo', JSON.stringify(commit))
      this.$store.commit('GLACCTNO_COMMIT_KEY', commit)
      this.$router.push({ name: 'glAcctNoDet' })
    },
    doReview(data) {
      if (data) {
        const commit = {
          branch: data.branch,
          glacctNo: data.glacctNo,
          fund: data.fund,
          acctNoSfx: data.acctNoSfx,
          curr: data.curr,
          postType: data.postType
        }
        sessionStorage.setItem('glacctNo', JSON.stringify(commit))
        this.$store.commit('GLACCTNO_COMMIT_KEY', commit)
        this.$router.push({ name: 'glAcctNoDet' })
      }
    },
    doQuery(data) {
      if (data) {
        const commit = {
          branch: data.branch,
          glacctNo: data.glacctNo,
          fund: data.fund,
          acctNoSfx: data.acctNoSfx,
          curr: data.curr,
          postType: data.postType
        }
        sessionStorage.setItem('glacctNo', JSON.stringify(commit))
        this.$store.commit('GLACCTNO_COMMIT_KEY', commit)
        this.$router.push({ name: 'glAcctNoDetQuery' })
      }
    },
    postType(value) {
      return postType[value]
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    postTypeList() {
      let result = []
      Object.keys(postType).forEach((key) => {
        const status = postType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
